import { render, staticRenderFns } from "./CamposCustomizadosTabela.vue?vue&type=template&id=7c134991&lang=html"
import script from "./CamposCustomizadosTabela.vue?vue&type=script&lang=js"
export * from "./CamposCustomizadosTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports